import { ourGuaranteesPresets } from './types';
import { useAuthentication } from '@context/businessContainer';
import { useSubscribeInCheckout } from '@monofront/business/hooks/checkout/useSubscribeInCheckout';

const useGetGuaranteesPreset = (): ourGuaranteesPresets => {
  const { isMember } = useAuthentication();
  const { isSubscriptionAvailable } = useSubscribeInCheckout(useAuthentication);

  let preset = ourGuaranteesPresets.SUBSCRIPTION;

  if (isSubscriptionAvailable) preset = ourGuaranteesPresets.PROSPECT;
  else if (isMember) preset = ourGuaranteesPresets.SERVICE;

  return preset;
};

export default useGetGuaranteesPreset;
